<template>
    <svg v-b-tooltip.hover.bottom="'Archive'" width="28" height="28" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12.8564" r="12" fill="#F9F9F9"/>
        <path d="M17.8804 9.91309H6.07383C5.92838 9.91309 5.80259 9.96837 5.69641 10.079C5.59018 10.1896 5.53711 10.3207 5.53711 10.4721V18.8575C5.53711 19.0088 5.59018 19.1399 5.69641 19.2505C5.80259 19.3612 5.92838 19.4166 6.07383 19.4166H17.8804C18.0258 19.4166 18.1515 19.3612 18.2577 19.2505C18.3639 19.14 18.417 19.0089 18.417 18.8575V10.4721C18.417 10.3206 18.3641 10.1897 18.2577 10.079C18.1516 9.96837 18.0258 9.91309 17.8804 9.91309ZM13.4276 12.5422C13.3215 12.6529 13.1956 12.7082 13.0503 12.7082H10.9036C10.7584 12.7082 10.6326 12.6528 10.5263 12.5422C10.4201 12.4316 10.367 12.3006 10.367 12.1491C10.367 11.9977 10.4201 11.8667 10.5263 11.7561C10.6325 11.6454 10.7583 11.59 10.9036 11.59H13.0505C13.1957 11.59 13.3215 11.6454 13.4278 11.7561C13.5339 11.8666 13.587 11.9977 13.587 12.1491C13.587 12.3006 13.5338 12.4316 13.4276 12.5422Z" fill="#B8CDD7"/>
        <path d="M18.7941 6.16594C18.6878 6.05528 18.5621 6 18.4167 6H5.53666C5.39133 6 5.26554 6.05528 5.15933 6.16594C5.05313 6.27654 5 6.40758 5 6.55899V8.79509C5 8.94647 5.05313 9.07744 5.15936 9.18813C5.26557 9.29879 5.39133 9.35407 5.53669 9.35407H18.4165C18.5619 9.35407 18.6877 9.29879 18.7941 9.18813C18.9002 9.07747 18.9533 8.9465 18.9533 8.79509V6.55899C18.9533 6.40748 18.9002 6.27654 18.7941 6.16594Z" fill="#B8CDD7"/>
    </svg>
</template>

<script>
export default {

}
</script>

<style scoped lang="scss">

    svg {
        path, circle {
            transition: all 0.2s ease;
        }
        &:focus {
            outline: 0 !important;
        }
        &:hover {
            path {
                fill: #F9F9F9 !important;
            }
            circle {
                fill: #B8CDD7 !important;
            }
        }
    }

</style>